import "./Capacity.css";

import e1 from "./assets/c1.svg";
import e2 from "./assets/c2.svg";
import e3 from "./assets/c3.svg";
import e4 from "./assets/c4.svg";
import e5 from "./assets/c5.svg";

const CapacityBusiness = () => {
  const cards = [
    {
      id: "resource-costs",
      img: e1,
      title: "Resources and Control Costs",
      desc: "Prevent overspending by optimizing resource use for efficient operations.",
    },
    {
      id: "service-delivery",
      img: e2,
      title: "Service Delivery",
      desc: "Meet deadlines reliably with the right resources, boosting trust and satisfaction.",
    },
    {
      id: "strategic-decisions",
      img: e3,
      title: "Strategic Decisions",
      desc: "Use data-driven insights to guide smarter business strategies and investments.",
    },
    {
      id: "operational-agility",
      img: e4,
      title: "Operational Agility and Resilience",
      desc: "Quickly adapt to changes to maintain smooth, uninterrupted operations.",
    },
    {
      id: "scalable-growth",
      img: e5,
      title: "Scalable Growth",
      desc: "Align capacity with future demand for efficient, sustainable business expansion.",
    },
  ];

  return (
    <section className="capacity-section">
      <h2 className="capacity-title">
        Why We Recommend Capacity Planning
        <br /> for Your Business
      </h2>

      <div className="capacity-grid">
        {cards.map((item) => (
          <div key={item.id} className="capacity-card">
            <img src={item.img} alt={item.title} className="capacity-icon" />

            <h3 className="capacity-card-title">{item.title}</h3>

            <p className="capacity-card-desc">{item.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default CapacityBusiness;
